import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/components/spinner/Spinner.less');
const cx = classnames.bind(styles);

export enum SpinnerSize
{
    Medium_16 = 16,
    Medium_20 = 20,
    Medium_24 = 24,
    Large_32 = 32,
    Large_48 = 48,
    Large_64 = 64
}

export enum SpinnerStyle
{
    White = 'White',
    Blue = 'Blue'
}

export enum SpinnerWeight
{
    Thin = 2,
    Normal = 1
}

export interface ISpinnerProps
{
    size?:SpinnerSize | number;
    style?:SpinnerStyle;
    weight?:SpinnerWeight | number;
    wrapperClassName?:string;
    className?:string;
}

export class Spinner extends React.Component<ISpinnerProps, any>
{
    public shouldComponentUpdate(nextProps:ISpinnerProps):boolean
    {
        const {size, style, weight, className} = this.props;

        return (
            size !== nextProps.size ||
            style !== nextProps.style ||
            weight !== nextProps.weight ||
            className !== nextProps.className
        );
    }

    public render():JSX.Element
    {
        const {
            style = SpinnerStyle.White,
            size = SpinnerSize.Medium_16,
            wrapperClassName,
            className
        } = this.props;

        return (
            <div className={cx('spinnerWrapper',
                {'whiteSpinner': style === SpinnerStyle.White},
                {'blueSpinner': style === SpinnerStyle.Blue},
                wrapperClassName)}
            >
                <div className={cx('spinner', className)} />
            </div>
        );
    }
}





